export default "varying mediump vec2 vUV;\n\nvoid main() {\n    vUV = uv;\n    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}\n"